import axios from "axios";

const EXTERNAL_API_BASE_URL = "https://api.boostr.cl";

export interface ExternalRegion {
  id: number;
  name: string;
}

export interface ExternalComuna {
  id: number;
  region_id: number;
  name: string;
}

export interface ExternalApiResponse<T> {
  status: string;
  data: T[];
}

// Cliente para la API externa
const externalApiClient = axios.create({
  baseURL: EXTERNAL_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Obtener todas las regiones
export const getExternalRegions = async (): Promise<ExternalRegion[]> => {
  try {
    const response = await externalApiClient.get<
      ExternalApiResponse<ExternalRegion>
    >("/geography/regions.json");
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo regiones externas:", error);
    throw new Error("Error obteniendo regiones");
  }
};

// Obtener todas las comunas
export const getExternalComunas = async (): Promise<ExternalComuna[]> => {
  try {
    const response = await externalApiClient.get<
      ExternalApiResponse<ExternalComuna>
    >("/geography/communes.json");
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo comunas externas:", error);
    throw new Error("Error obteniendo comunas");
  }
};

// Obtener comunas filtradas por región
export const getExternalComunasByRegion = async (
  regionId: number
): Promise<ExternalComuna[]> => {
  try {
    const response = await externalApiClient.get<
      ExternalApiResponse<ExternalComuna>
    >("/geography/communes.json");
    const allComunas = response.data.data;
    return allComunas.filter((comuna) => comuna.region_id === regionId);
  } catch (error) {
    console.error("Error obteniendo comunas por región:", error);
    throw new Error("Error obteniendo comunas por región");
  }
};
